import { AbstractControl, ValidationErrors } from '@angular/forms';

export function cpfValidator(control: AbstractControl): ValidationErrors | null {
  return cpfNumberValidator(control.value);
}

export function cpfNumberValidator(value: string): ValidationErrors | null {
  const cpf = (value || '').replace(/\D/g, '');
  if(cpf.length >= 11){
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)){
      return { cpfInvalido: true };
    }
    let sum = 0;
    for (let i = 0; i < 9; i++){
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11){
      rest = 0;
    }
    if (rest !== parseInt(cpf.charAt(9))){
      return { cpfInvalido: true };
    }
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11){
      rest = 0
    };
    if (rest !== parseInt(cpf.charAt(10))) {
      return { cpfInvalido: true }
    };
  }
  return null;
}
